module.exports = __webpack_public_path__ + "img/group-active-mobile.e349869b.svg";